import tippy from "tippy.js";
import jquery from "jquery";

const $ = jquery;

$(document).ajaxSuccess(() => {
    initLabelTooltip();
});

window.addEventListener("load", initLabelTooltip());

function initLabelTooltip() {
    const tooltips = document.querySelectorAll(".js-tooltip");
    if (tooltips && tooltips.length > 0) {
        for (const tooltip of tooltips) {
            if (!tooltip.classList.contains("tooltip-initialized")) {
                tippy(tooltip, {
                    arrow: true,
                    placement: "top", // top, right, bottom, left
                    trigger: "mouseenter click",
                    interactive: true,

                    allowHTML: true,
                    hideOnClick: true,
                    theme: tooltip.hasAttribute("data-tooltip-theme")
                        ? `${tooltip.getAttribute("data-tooltip-theme")}`
                        : "light",
                    content: tooltip.querySelector(".js-tooltip-content"),
                    appendTo: () => document.body,
                });
                tooltip.classList.add("tooltip-initialized");
            }
        }
    }
}
